import { FC } from 'react';

import styles from './projectVacancy.module.scss';

import TableVacancy from '../../../components/table/recruiting/tableVacancyList';

const ProjectVacancy: FC = () => {
	return (
		<div className={styles.vacancy}>
			<TableVacancy />
		</div>
	);
};

export default ProjectVacancy;
